import { motion } from "framer-motion";

const WORDMARK_URL =
"https://customer-assets.emergentagent.com/job_merai-future/artifacts/iffhv94g_Asset%208%403x.png";

const NAV_GROUPS = [
{
  label: "Products",
  links: [
  "AI Stylist + VTON",
  "GenAI at Scale",
  "AI Visual Merchandising",
  "AI Techpacking"]

},
{
  label: "Company",
  links: ["About", "Careers"]
},
{
  label: "Contact",
  links: ["Book a Demo", "hello@wearemerai.ai", "LinkedIn"]
}];


const scrollTo = (id) =>
document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Footer = () =>
<footer
  data-testid="footer"
  className="bg-[#E8380D] border-t border-black/10">
  
    {/* Footer nav section */}
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 pt-20 pb-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
        {/* Tagline column */}
        <div className="col-span-2 md:col-span-1">
          <p className="font-mono text-xs uppercase tracking-widest text-black/45 mb-3">
            MERAI
          </p>
          <p className="font-manrope text-sm text-black/70 leading-relaxed max-w-xs">
            The operating intelligence layer for modern retail. Built not to
            assist, but to transform.
          </p>
        </div>

        {/* Link groups */}
        {NAV_GROUPS.map((group) =>
      <div key={group.label}>
            <p className="font-mono text-xs uppercase tracking-widest text-black/45 mb-4">
              {group.label}
            </p>
            <ul className="space-y-2.5">
              {group.links.map((link) =>
          <li key={link}>
                  <button
              data-testid={`footer-link-${link.
              toLowerCase().
              replace(/\s+/g, "-").
              replace(/[^a-z0-9-]/g, "")}`}
              onClick={() => {
                if (link === "Book a Demo") scrollTo("contact");
              }}
              className="font-manrope text-sm text-black/70 hover:text-black transition-colors duration-150">
              
                    {link}
                  </button>
                </li>
          )}
            </ul>
          </div>
      )}
      </div>

      <div className="border-t border-black/10 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
        <p className="font-mono text-xs text-black/40 uppercase tracking-wider">
          © 2026 MERAI. All rights reserved.
        </p>
        <p className="font-mono text-xs text-black/40 uppercase tracking-wider">
          Merai — 未来 — Future
        </p>
      </div>
    </div>

    {/* Massive wordmark — black canvas so logo bg blends */}
    <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 1 }}
    viewport={{ once: true }}
    className="bg-[#0A0A0A] overflow-hidden"
    data-testid="footer-wordmark">
    
      <img
      src={WORDMARK_URL}
      alt="MERAI"
      className="w-full object-contain !opacity-[20%]"
      style={{ maxHeight: "26vw", minHeight: "120px" }} />
    
    </motion.div>
  </footer>;


export default Footer;